module.exports = __webpack_public_path__ + "static/media/07.95a24c53.svg";